import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M12.342 14.444a.84.84 0 00-.462 1.091.84.84 0 01-.176.915l-2.376 2.377a1.68 1.68 0 01-2.376 0l-1.78-1.789a1.68 1.68 0 010-2.376l2.376-2.368a.84.84 0 01.915-.177.84.84 0 10.638-1.553 2.518 2.518 0 00-2.745.546L3.98 13.486a3.36 3.36 0 000 4.744l1.788 1.789a3.357 3.357 0 004.744 0l2.375-2.376a2.519 2.519 0 00.546-2.746.84.84 0 00-1.091-.454z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M8.438 15.56a.84.84 0 001.184 0l6.573-6.533a.84.84 0 00-1.183-1.184l-6.574 6.533a.84.84 0 000 1.184z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M20.014 5.761l-1.788-1.78a3.358 3.358 0 00-4.743 0l-2.376 2.376a2.52 2.52 0 00-.546 2.746.84.84 0 101.553-.638.84.84 0 01.176-.915l2.376-2.377a1.68 1.68 0 012.376 0l1.78 1.789a1.68 1.68 0 010 2.376l-2.376 2.36a.84.84 0 01-.915.184.84.84 0 00-.638 1.554 2.518 2.518 0 002.745-.546l2.376-2.376a3.359 3.359 0 000-4.753z",
      fill: "#333"
    }
  )
), t = e;
export {
  t as default
};
